import { Service } from './request';
//给接口数据定义范形
// 搜索接口
export function getBaseInfo(data) {
    return Service({
        // url: `/api/api/info/${data.code}/${data.type}`, // 本地启动时开启，发测试和线上请用下面的
        url: "/api/info/".concat(data.code, "/").concat(data.type),
        method: 'GET',
    });
}
// 查询pdf接口
export function getPdfBase64(config) {
    return Service({
        url: '/api/doc',
        method: 'POST',
        data: config,
    });
}
// 签字回传
export function getSubmitImg(params) {
    return Service({
        url: '/api/signed',
        method: 'POST',
        data: params,
    });
}
// 点击结算/支付获取支付链接
export function getPaymentUrl(params) {
    return Service({
        url: '/api/pay',
        method: 'POST',
        data: params,
    });
}
// 更新追账账单
export function updateInvoice(params) {
    return Service({
        url: "/api/payment/".concat(params.merTradeNo),
        method: 'GET',
    });
}
// 实时获取trakcare账单详情
export function getBill(params) {
    return Service({
        url: "/api/getBill/".concat(params.invoiceRowId),
        method: 'GET',
    });
}
// 手机端点击结算 获取收钱吧 链接
export function getPurchaseUrl(params) {
    return Service({
        url: '/api/sqbPay/purchase',
        method: 'POST',
        data: params,
    });
}
// 轮询获取支付结果
export function getQueryResult(params) {
    return Service({
        url: '/api/sqbPay/query',
        method: 'POST',
        data: params,
    });
}
